export const AGENTPOINT_EMAIL_TEMPLATE = {
  to: 'helpdesk@agentpoint.com.au',
  cc: 'help@snug.com',
  subject: 'Enable Snug as Upload Destination - Agency Setup',
  body: `Hello AgentPoint

Could you please enable Snug as an upload destination for our agency for the AgentPoint Account(s):

- [Enter your Agency ID here]

Please assign the AgentPoint Agency ID and provide it to us.

Thank you,

Head of Property Management`,
}
